import { getInstance } from "./authWrapper";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
        
    if (authService.isAuthenticated) {
      
      const matchedRole = to.meta.roles.find(function(role) {
        return authService.userRole === role;
      })

      if(matchedRole) {
        return next();
      }
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};